import React from 'react'
import '../Footer/Footer.css'
const Footer = () => {
  return (
            <div className='ft'>
              
              <p></p>
            </div>
  )
}

export default Footer